import { createAction } from '@reduxjs/toolkit';

export default createAction('updateEntityVersion', (versionNumber) => ({
  payload: versionNumber,
}));
